
export const Footer = () => {
  return (
    <div className='w-100 fixed bottom-0 left-0 right-0 bg-gray-200 text-center'>
        <h2 className='tracking-wider'>
          <a target="_blank" href="https://quotes.immortall.my.id"> 
          denpaDev &copy; 2023.
          </a>
        </h2>
    </div>
  )
}
